<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.rb_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="rb_custname">
            <label class="weui-form-preview__label">{{
              customLabel.rb_custname || "客户"
            }}</label>
            <em class="weui-form-preview__value">{{
              form.main.rb_custname
            }}</em>
          </div>
          <div class="weui-form-preview__item" slot="rb_seller">
            <label class="weui-form-preview__label">{{
              customLabel.rb_seller || "业务员"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.rb_seller
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_caleftamount">
            <label class="weui-form-preview__label">{{
              customLabel.rb_caleftamount || "总欠款(元)"
            }}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.rb_caleftamount
            }}</span>
          </div>
          <div
            class="weui-form-preview__item"
            v-if="form.main.rb_preamount"
            slot="rb_preamount"
          >
            <label class="weui-form-preview__label">{{
              customLabel.rb_preamount || "本次预收(元)"
            }}</label>
            <span class="weui-form-preview__value" v-format="'¥#,##0.00'">{{
              form.main.rb_preamount
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="rb_currency">
            <label class="weui-form-preview__label">{{
              customLabel.rb_currency || "币种"
            }}</label>
            <span class="weui-form-preview__value">
              {{ form.main.rb_currency }}
              <span v-if="form.main.rb_rate && form.main.rb_rate != 1"
                >/ {{ form.main.rb_rate }}</span
              >
            </span>
          </div>
          <div class="weui-form-preview__item" slot="rb_date">
            <label class="weui-form-preview__label">{{
              customLabel.rb_date || "日期"
            }}</label>
            <span class="weui-form-preview__value">{{
              form.main.rb_date
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.rb_text1 || '自定义字段1'"
          v-model="form.main.rb_text1" slot="rb_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text2 || '自定义字段2'"
          v-model="form.main.rb_text2" slot="rb_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text3 || '自定义字段3'"
          v-model="form.main.rb_text3" slot="rb_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text4 || '自定义字段4'"
          v-model="form.main.rb_text4" slot="rb_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.rb_text5 || '自定义字段5'"
          v-model="form.main.rb_text5" slot="rb_text5" hidden="true" />
        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items1"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="rd_bankname">
              <label class="weui-form-preview__label">{{
                customLabel.rd_bankname || "记账科目"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.rd_bankcode }} {{ item.rd_bankname }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="rd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.rd_amount || "收款金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.rd_amount,'#,##0.00')
              }}</span>
            </div>
            <div
              class="weui-form-preview__item"
              v-if="item.rd_paymethod"
              slot="rd_paymethod"
            >
              <label class="weui-form-preview__label">{{
                customLabel.rd_paymethod || "结算方式"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.rd_paymethod
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.rd_text1 || '自定义字段1'"
            v-model="item.rd_text1" slot="rd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rd_text2 || '自定义字段2'"
            v-model="item.rd_text2" slot="rd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rd_text3 || '自定义字段3'"
            v-model="item.rd_text3" slot="rd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rd_text4 || '自定义字段4'"
            v-model="item.rd_text4" slot="rd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rd_text5 || '自定义字段5'"
            v-model="item.rd_text5" slot="rd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div
        class="form-preview weui-form-preview"
        v-if="form.items2 && form.items2.length"
      >
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items2"
          :key="item.id"
        >
          <custom-layout :view-config="customViewConfig" position="detail2">
            <div class="weui-form-preview__item" slot="rbd_slcode">
              <label class="weui-form-preview__label">{{
                customLabel.rbd_slcode || "来源单号"
              }}</label>
              <span class="weui-form-preview__value"
                >{{ item.rbd_slkind }} {{ item.rbd_slcode }}</span
              >
            </div>
            <div class="weui-form-preview__item" slot="rbd_seller">
              <label class="weui-form-preview__label">{{
                customLabel.rbd_seller || "业务员"
              }}</label>
              <span class="weui-form-preview__value">{{
                item.rbd_seller
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="rbd_amount">
              <label class="weui-form-preview__label">{{
                customLabel.rbd_amount || "单据金额"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.rbd_amount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="sl_yamount">
              <label class="weui-form-preview__label">{{
                customLabel.sl_yamount || "已核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value" >{{
                numberFormat(item.sl_yamount,'#,##0.00')
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="rbd_nowbalance">
              <label class="weui-form-preview__label">{{
                customLabel.rbd_nowbalance || "本次核销金额(元)"
              }}</label>
              <span class="weui-form-preview__value">{{
                numberFormat(item.rbd_nowbalance,'#,##0.00')
              }}</span>
            </div>
            <custom-field :readOnly="true" :label="customLabel.rbd_text1 || '自定义字段1'"
            v-model="item.rbd_text1" slot="rbd_text1" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rbd_text2 || '自定义字段2'"
            v-model="item.rbd_text2" slot="rbd_text2" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rbd_text3 || '自定义字段3'"
            v-model="item.rbd_text3" slot="rbd_text3" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rbd_text4 || '自定义字段4'"
            v-model="item.rbd_text4" slot="rbd_text4" hidden="true" />
            <custom-field :readOnly="true" :label="customLabel.rbd_text5 || '自定义字段5'"
            v-model="item.rbd_text5" slot="rbd_text5" hidden="true" />
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item" v-if="form.main.rb_remark">
            <label class="weui-form-preview__label">备注</label>
            <span class="weui-form-preview__value">{{
              form.main.rb_remark
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">总收款金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.rb_rdamount
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">总核销金额(元)</label>
            <span class="weui-form-preview__value" v-format="'#,##0.00'">{{
              form.main.rb_rbdamount
            }}</span>
          </div>
        </div>
      </div>
      <div class="footer-bar weui-dialog__ft">
        <share class="weui-dialog__btn weui-dialog__btn_default" v-if="!editable" :biz-data="bizData"></share>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import Share from "@/components/button/Share.vue";
import form from "@/mixins/form.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Share,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/money/recbalance",
      caller: "RecBalance",
      xtype: "money-recbalance-formpanel",
      form: {
        main: {},
        items1: [],
        items2: [],
      },
    };
  },
  computed: {
    bizData() {
      var main = this.form.main;
      if (!main) {
        return null;
      }
      return {
        bizCode: main.rb_code,
        bizType: "RecBalance",
        bizId: main.id,
        viewType: "money-recbalance-formpanel",
        title: "收款单" + main.rb_code,
      };
    },
  }
};
</script>